<template>
  <div class="xcard">
    <v-toolbar-title class="mb-5 py-2" style="border-bottom: 1px solid #d4dbe0">
      <span>SEDES* DE PRESUPUESTOS</span>
      <small class="ml-3 caption">(* No figuran en el ESAM Portal)</small>
    </v-toolbar-title>

    <v-row>
      <v-col cols="12" md="9" xl="10" class="pa-2 pb-0">
        <v-btn small color="primary" class="mr-2" title="Registrar" @click="$refs.modalFormSedeRef.abrir('registrar')">
          <v-icon>mdi-plus</v-icon>
        </v-btn>

        <v-btn
          small
          class="mr-2"
          :disabled="item == null"
          title="Editar"
          @click="$refs.modalFormSedeRef.abrir('editar', item)">
          <v-icon>mdi-pencil</v-icon>

          Editar
        </v-btn>

        <v-btn
          small
          class="mr-2"
          :disabled="item == null"
          title="Eliminar"
          @click="() => confirmacionAccion(accionesAConfirmar.ELIMINAR, item.nombre)">
          <v-icon>mdi-close</v-icon>

          Eliminar
        </v-btn>

        <v-btn small class="mr-2" @click="listar" title="Recargar">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </v-col>

      <v-col cols="12" md="3" xl="2" class="pa-2 pb-0">
        <v-text-field
          dense
          outlined
          hide-details
          v-model="searchQuery"
          append-icon="mdi-magnify"
          label="Buscar"
          clearable
          @input="updateSearchQuery"></v-text-field>
      </v-col>

      <v-col cols="12" class="pa-2 pb-4">
        <ListadoSede ref="listadoRef" :items="items" :cargando="cargando" @selectItem="selectItem" />
      </v-col>
    </v-row>

    <ModalFormSede ref="modalFormSedeRef" :nombreRecurso="nombreRecurso" @actualizarListado="listar" />

    <notifications group="notifications" position="top right" />

    <ConfirmacionAccion
      ref="confirmacionRef"
      :titulo="confirmacion.titulo"
      :mensaje="confirmacion.mensaje"
      :realizandoAccion="confirmacion.realizandoAccion"
      @aceptar="confirmacion.fnAceptar" />
  </div>
</template>

<script>
import SedesService from './../services/sedes-service';
import ModalFormSede from './../components/ModalFormSede.vue';
import ListadoSede from './../views/ListadoSede.vue';
import LayoutMixin from '../mixins/layout-mixin';

export default {
  name: 'SedesPresupuestos',
  mixins: [LayoutMixin],
  components: {
    ListadoSede,
    ModalFormSede,
  },
  data() {
    return {
      servicioListarItems: SedesService.get,
      nombreRecurso: 'SEDE',
      confirmacion: {
        titulo: '',
        mensaje: '',
        realizandoAccion: false,
      },
    };
  },
  mounted() {
    this.listar();
  },
  methods: {
    async listar() {
      this.listarMixin();
    },
    async getResponseAccion(accion) {
      let response = null;

      if (accion === this.accionesAConfirmar.ELIMINAR) {
        response = await SedesService.destroy(this.item.id);
      }

      return response;
    },
  },
};
</script>

<style scoped>
::v-deep .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections {
  padding: 0px 0;
}

::v-deep .v-text-field .v-label {
  font-weight: 400;
}

::v-deep .v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}

::v-deep .v-text-field--outlined.v-input--dense .v-label {
  top: 5px;
}

::v-deep .v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-inner,
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-outer,
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-inner,
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-outer,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-inner,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-outer,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-inner,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-outer {
  margin-top: 5px;
}
</style>